export default __webpack_public_path__ + "static/media/podcasts_icon.ae945592.svg";